import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { EntityOffer, PaymentInterface } from '../../../new-lib/types/entity';
import { EntityTypes } from '../../../new-lib/constants/common';
import CashDiscountCard from '../components/payment-plans/CashDiscountCard';

const MobilePaymentPlansPresentation = dynamic(
  () => import('./MPaymentPlansPresentation')
);
const DesktopPaymentPlansPresentation = dynamic(
  () => import('./PaymentPlansPresentation')
);

interface ChildProps {
  entityType: EntityTypes;
  paymentPlans: PaymentInterface[];
  showOffers: boolean;
  offers: EntityOffer[];
}

const PaymentPlansContainer = ({
  entityType,
  paymentPlans,
  showOffers,
  offers
}: ChildProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const [propertyCashDiscount, setPropertyCashDiscount] =
    useState<PaymentInterface>();

  const filterPlan = (plan: PaymentInterface) => {
    if (
      entityType == EntityTypes.COMPOUND &&
      plan?.down_payment.percent != null &&
      plan?.years != null
    ) {
      return plan;
    } else {
      return;
    }
  };

  const filterOffer = (offer: EntityOffer) => {
    if (
      entityType == EntityTypes.COMPOUND &&
      (offer.offer?.cash_discount.percent != null ||
        (offer.offer?.down_payment.percent != null &&
          offer.offer?.years != null) ||
        offer.discount != null)
    )
      return offer;

    return null;
  };

  const [filteredPlans, setFilteredPlans] = useState<PaymentInterface[]>(
    paymentPlans.length > 0
      ? paymentPlans.filter((plan: PaymentInterface) => filterPlan(plan))
      : []
  );
  const [filteredOffers, setFilteredOffers] = useState<EntityOffer[]>(
    showOffers ? offers.filter((offer: EntityOffer) => filterOffer(offer)) : []
  );

  useEffect(() => {
    setFilteredOffers([]);
    setFilteredPlans([]);
    if (paymentPlans.length > 0) {
      let filteredPlans = paymentPlans.filter((plan: PaymentInterface) =>
        filterPlan(plan)
      );
      if (filteredPlans.length > 0) {
        setFilteredPlans(filteredPlans);
      }
    }

    if (showOffers && offers.length > 0) {
      const filteredOffers = offers.filter((offer: EntityOffer) =>
        filterOffer(offer)
      );

      if (filteredOffers.length > 0) {
        setFilteredOffers(filteredOffers);
      }
    }
  }, [paymentPlans, offers]);

  const getPropertyCashDiscount = () => {
    return propertyCashDiscount ? (
      <CashDiscountCard
        discountPercent={propertyCashDiscount.cash_discount.percent}
      />
    ) : null;
  };
  const getPaymentPlans = () => {
    const plansCount = filteredPlans.length + filteredOffers.length;

    return plansCount > 0 ? (
      isMobile ? (
        <MobilePaymentPlansPresentation
          plans={filteredPlans}
          offers={filteredOffers}
          entityType={entityType}
        />
      ) : (
        <DesktopPaymentPlansPresentation
          plans={filteredPlans}
          offers={filteredOffers}
          entityType={entityType}
        />
      )
    ) : null;
  };

  return (
    <>
      {getPropertyCashDiscount()}
      {getPaymentPlans()}
    </>
  );
};
export default PaymentPlansContainer;
